import { createActions } from 'redux-actions';
import { put, select } from 'redux-saga/effects';
import { apiActions as commonApiActions, apiResourceActionCreator, endpointQuery } from '../../common';
import { authTokenSelector } from '../../session';
import { API_ENDPOINT } from './endpoints';

const action = createActions({
  ADMIN: {
    GET_CONTENT_REPORT: (query) => ({ query }),
    API: {
      GET_CONTENT_REPORT: apiResourceActionCreator('contentReport')
    }
  }
})

export const apiAction = (authToken, query) => commonApiActions.authenticated.get(`${API_ENDPOINT}/reports/content${endpointQuery({ ...(query || {}) })}`, authToken, action.admin.api.getContentReport)

function* getContentReport(action) {
  const authToken = yield select(authTokenSelector);
  yield put(apiAction(authToken, action.payload && action.payload.query));
}

const configuration = {
  name: 'getContentReport',
  action: action,
  sagas: getContentReport,
  reducers: {
    request: (state, action) => ({
      ...state,
      isFetchingReport: true
    }),
    success: (state, action) => ({
      ...state,
      isFetchingReport: false,
      contentReport: action.payload.contentReport
    }),
    failed: (state, action) => ({
      ...state,
      isFetchingReport: false
    })
  }
}

export default configuration;


// WEBPACK FOOTER //
// ./src/state/modules/admin/configurations/getContentReport.js